import { FunctionComponent, useEffect, useState } from 'react';
import './ImageRichTextTile.scss';
import { Heading } from '@lmig/lmds-react-typography';
import RichText from './RichText';

interface IImageRichTextTile {
  parentfolderid: string;
  backgroundimage: IGlassImage;
  backgroundimageposition: string;
  richtext: string;
  title: string;
}

const ImageRichTextTile: FunctionComponent<IImageRichTextTile> = (props: IImageRichTextTile) => {
  const [richTextTile, setRichTextTile] = useState<IImageRichTextTile | undefined>(undefined);
  const [richTextTileKey, setRichTextTileKey] = useState<number>(0);

  useEffect(() => {
    setRichTextTile(props);
    setRichTextTileKey((prevKey) => prevKey + 1);
  }, [props]);

  const onTileRefresh = async () => {
    let response = await fetch(`/api/sitecore/PageContentAsync/GetImageRichTextTile`, {
      method: 'POST',
      body: new URLSearchParams({ parentfolderid: richTextTile ? richTextTile.parentfolderid : '' }),
    });

    if (response.ok) {
      try {
        let data = await response.json();

        if (data?.success && data?.data !== null) {
          let newRichTextTile = {} as IImageRichTextTile;
          newRichTextTile.parentfolderid = data.data.parentFolderId;
          newRichTextTile.backgroundimage = data.data.backgroundImage as IGlassImage;
          newRichTextTile.backgroundimageposition = data.data.backgroundPosition;
          newRichTextTile.richtext = data.data.richText;
          newRichTextTile.title = data.data.title;

          setRichTextTile(newRichTextTile);
          setRichTextTileKey((prevKey) => prevKey + 1);
        } else {
          console.log(`Failed Call to GetImageRichTextTile
            \nstatusCode: ${data?.statusCode}
            \nerror: ${data?.error}`);
        }
      } catch (err: any) {
        console.log(`ERROR in GetImageRichTextTile:
          \n${err}
          \n${err.message}`);
      }
    }
  };

  return (
    <>
      <div className={'image-rich-text-tile-wrapper'} key={richTextTileKey}>
        {richTextTile ? (
          <div
            className={'image-rich-text-tile'}
            style={{
              backgroundImage: `url("${richTextTile.backgroundimage?.Src}")`,
              backgroundPosition: `${richTextTile.backgroundimageposition || 'center'}`,
              backgroundSize: 'cover',
            }}
          >
            {richTextTile.title && richTextTile.title.length > 0 ? (
              <div className={'image-rich-text-tile-header'}>
                <div className={'image-rich-text-tile-header-title-container'}>
                  <Heading className="custom-tile-heading-margin" type="h4-light">
                    {richTextTile.title}
                  </Heading>
                </div>
              </div>
            ) : null}
            <div className={'image-rich-text-tile-body'}>
              <RichText
                className="image-rich-text-full-width"
                content={richTextTile.richtext}
                onTileRefresh={onTileRefresh}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ImageRichTextTile;
